/* =========================================================
   Signature Authenticity Verification
   - 스크롤 진입 시 티저 영상 자동재생
   - 사운드 토글
   - 전체 영상 모달
   ========================================================= */

(function () {
  const sections = document.querySelectorAll('[data-sigav]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const teaser = section.querySelector('[data-role="teaser"]');
    const soundBtn = section.querySelector('[data-action="toggle-sound"]');
    const modal = section.querySelector('[data-role="modal"]');
    const fullVideo = section.querySelector('[data-role="full"]');
    const openModalBtn = section.querySelector('[data-action="open-modal"]');
    const closeModalBtns = section.querySelectorAll('[data-action="close-modal"]');
    const autoplayOnView = section.dataset.autoplayOnView === 'true';

    // -----------------------------
    // 공통 유틸
    // -----------------------------
    const safePlay = (video) => {
      if (!video) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const safePause = (video) => {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
    };

    const setSoundState = () => {
      if (!teaser || !soundBtn) return;
      soundBtn.classList.toggle('is-unmuted', !teaser.muted);
    };

    // -----------------------------
    // 티저 영상
    // -----------------------------
    if (teaser) {
      teaser.muted = true;
      teaser.loop = true;
      teaser.playsInline = true;

      setSoundState();

      if (autoplayOnView && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.28) {
                safePlay(teaser);
              } else {
                safePause(teaser);
              }
            });
          },
          {
            threshold: [0, 0.15, 0.28, 0.45, 0.7]
          }
        );

        observer.observe(section);
      } else {
        safePlay(teaser);
      }

      if (soundBtn) {
        soundBtn.addEventListener('click', () => {
          if (teaser.paused) safePlay(teaser);
          teaser.muted = !teaser.muted;
          setSoundState();
        });
      }
    }

    // -----------------------------
    // 모달 열기/닫기
    // -----------------------------
    const openModal = () => {
      if (!modal) return;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sigav-modal-open');

      // 배경 티저는 잠시 정지
      safePause(teaser);

      if (fullVideo) {
        safePlay(fullVideo);
      }
    };

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sigav-modal-open');

      if (fullVideo) {
        safePause(fullVideo);
        try {
          fullVideo.currentTime = 0;
        } catch (e) {}
      }

      // 다시 화면 안에 있으면 티저 재생
      if (teaser && autoplayOnView) {
        safePlay(teaser);
      }
    };

    if (openModalBtn && modal) {
      openModalBtn.addEventListener('click', openModal);
    }

    if (closeModalBtns.length) {
      closeModalBtns.forEach((btn) => {
        btn.addEventListener('click', closeModal);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  });
})();